import React, { useEffect } from "react";
import { Button, Dialog, Pane, Paragraph, Spinner, toaster, TrashIcon } from "evergreen-ui";
import { useStoreEditDetailsContext } from "../StoreEditDetailsContext";
import { useHistory } from "react-router-dom";
import { useDeleteStoreMutation } from "../../../datastore/StoreDataStore";

export interface DeleteStoreDialogProps {
    showDialog: boolean,
    setShowDialog: React.Dispatch<React.SetStateAction<boolean>>
}

export const DeleteStoreDialog = (props: DeleteStoreDialogProps) => {
    const history = useHistory();
    const { showDialog, setShowDialog } = props;

    const [
        deleteStore,
        {
            loading: deleteStoreLoading,
            error: deleteStoreError,
            called: deleteStoreCalled,
            data: deleteStoreData,
        },
    ] = useDeleteStoreMutation();

    const {
        store,
    } = useStoreEditDetailsContext();

    const onConfirm = () => {
        if (!store) {
            toaster.warning("Store not found. Please try again.");
            return;
        }
        deleteStore({
            storeId: store.id || "",
        });
    };

    useEffect(() => {
        if (deleteStoreCalled && !deleteStoreLoading) {
            if (deleteStoreError) {
                toaster.warning(deleteStoreError || "Error deleting store. Please try again.");
            } else if (deleteStoreData) {
                toaster.success("Store deleted", { duration: 2 });
                setShowDialog(false);
                history.replace("/stores");
                window.location.reload(); // Ensure we refresh the page to reflect the deletion
            }
        }
    }, [
        deleteStoreLoading,
        deleteStoreCalled,
        deleteStoreError,
        deleteStoreData,
    ]);

    return (
        <Dialog
            title={<h4 style={{ fontWeight: "400", padding: "0px", margin: "0px" }}>Delete Store</h4>}
            isShown={showDialog}
            hasClose={true}
            width={400}
            contentContainerProps={{
                display: "flex",
                padding: "30px",
                paddingTop: "0px",
                paddingBottom: "0px",
            }}
            onCloseComplete={() => setShowDialog(false)}
            onCancel={() => setShowDialog(false)}
            hasFooter={false}
        >
            <Pane>
                <Paragraph fontSize={13} lineHeight={"22px"}>
                    Are you sure you want to delete this store? If you only want to take down the public website, edit the Visibility settings in Domains.
                </Paragraph>
                <div style={{ display: "flex", justifyContent: "flex-start", marginTop: "24px" }}>
                    <Button
                        iconBefore={deleteStoreCalled ? <Spinner size={12} /> : <TrashIcon size={12} />}
                        disabled={deleteStoreCalled && deleteStoreLoading}
                        onClick={onConfirm}
                        size={"medium"}
                        appearance="primary"
                        height={40}
                        minWidth={150}
                        borderRadius={10}
                        marginBottom={30}
                    >
                        Delete
                    </Button>
                    <Button
                        size={"medium"}
                        height={40}
                        minWidth={150}
                        borderRadius={10}
                        marginBottom={30}
                        disabled={deleteStoreCalled && deleteStoreLoading}
                        onClick={() => setShowDialog(false)}
                        style={{ marginLeft: "10px" }}
                    >
                        Cancel
                    </Button>
                </div>
            </Pane>
        </Dialog >
    );
};
